// extracted by mini-css-extract-plugin
export default {"wrapper":"Prices_wrapper__72jia","container":"Prices_container__mJsot","middleSplit":"Prices_middleSplit__9dwpJ","img":"Prices_img__DU-bn","left":"Prices_left__Gzd53"};